/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Button, useBreakpoint } from 'sarsaparilla';

import { authModalActions } from 'shared-ui/auth/redux';
import { useTypedDispatch } from 'shared-ui/redux';

interface AccountSignInProps {
    isGuestLoginAllowed?: boolean;
}

export function SignInButton({ isGuestLoginAllowed }: AccountSignInProps) {
    const dispatch = useTypedDispatch();
    const { isMdAndDown } = useBreakpoint();

    if (isMdAndDown) {
        return null;
    }

    return (
        <Button
            id="ga-global-nav-log-in-link"
            appearance="link"
            aria-label="Sign Up or Log In"
            onClick={() => {
                if (isGuestLoginAllowed) {
                    dispatch(authModalActions.openLoginWithGuestModal());
                } else {
                    dispatch(authModalActions.openLoginModal());
                }
            }}
        >
            Sign Up / Log In
        </Button>
    );
}
